import { ThumbsDown, ThumbsUp } from 'lucide-react';

import type { AdminRunFeedback } from '@/api/adminClient';
import { formatDateTime } from '@/lib/format';

export function RunFeedbackSummary({
  feedback,
  compact = false,
  emptyLabel = 'No feedback',
}: {
  feedback?: AdminRunFeedback | null;
  compact?: boolean;
  emptyLabel?: string;
}) {
  const votes = feedback?.votes ?? [];
  if (votes.length === 0) {
    return <span className="text-muted-foreground">{emptyLabel}</span>;
  }

  const shown = compact ? votes.slice(0, 3) : votes;

  return (
    <div className="space-y-1">
      <p className="flex items-center gap-3 text-sm tabular-nums">
        <span
          className="inline-flex items-center gap-1 text-emerald-600 dark:text-emerald-400"
          title="Thumbs up"
        >
          <ThumbsUp className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="sr-only">Thumbs up</span>
          {feedback?.upCount ?? 0}
        </span>
        <span
          className="inline-flex items-center gap-1 text-red-600 dark:text-red-400"
          title="Thumbs down"
        >
          <ThumbsDown className="h-3.5 w-3.5" aria-hidden="true" />
          <span className="sr-only">Thumbs down</span>
          {feedback?.downCount ?? 0}
        </span>
      </p>
      <ul className="space-y-0.5 text-xs leading-5">
        {shown.map((vote) => (
          <li key={`${vote.userId}:${vote.updatedAt}`}>
            <span className="font-medium text-foreground">
              {vote.displayName || vote.email || 'Unknown user'}
            </span>
            <span className="text-muted-foreground">
              {' '}
              {vote.rating === 'up' ? 'thumbs up' : 'thumbs down'}
              {compact ? '' : ` · ${formatDateTime(vote.updatedAt)}`}
            </span>
          </li>
        ))}
        {compact && votes.length > shown.length ? (
          <li className="text-muted-foreground">+{votes.length - shown.length} more</li>
        ) : null}
      </ul>
    </div>
  );
}
